/**
 * DR-3021: the Pages row is one document-level split (or the image processor).
 * `uniquePageCount` is the size of that split. The splitter stores it while
 * the stage is still `processing`, and a later failure leaves the number in
 * place.
 *
 * Counts follow the `DocumentProcessingStatus` contract. `completedCount` is
 * the terminal size (`done`, `error`, or `skip`). `erroredCount` and
 * `skippedCount` are subsets of it, never a separate bucket. On error the
 * whole set is the errored subset, so the badge settles at 0. That means the
 * split stage failed. It does not mean each page failed. A non-terminal
 * status reports no settled pages. The stored count stays the row total.
 */
export type PagesRowCounts = {
  completedCount: number;
  erroredCount: number;
  skippedCount: number;
};

const pageCount = (uniquePageCount: number) =>
  Number.isFinite(uniquePageCount) && uniquePageCount > 0 ? uniquePageCount : 0;

export function pagesRowCounts(status: string | undefined, uniquePageCount: number): PagesRowCounts {
  const count = pageCount(uniquePageCount);
  const terminal = status === 'done' || status === 'error' || status === 'skip';

  return {
    completedCount: terminal ? count : 0,
    erroredCount: status === 'error' ? count : 0,
    skippedCount: status === 'skip' ? count : 0,
  };
}
